import React from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import WorkspaceLayout from '../components/Workspace/WorkspaceLayout';
import ExerciseDashboard from '../components/TableTopExercise/ExerciseDashboard';
import CreateExerciseForm from '../components/TableTopExercise/CreateExerciseForm';
import ExerciseDetail from '../components/TableTopExercise/ExerciseDetail';
import { TabletopHeaderActionsSlot } from '../contexts/TabletopHeaderActionsContext';

const TableTopExercises: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboard = location.pathname.replace(/\/+$/, '') === '/tabletop-exercises';

  return (
    <WorkspaceLayout
      title={isDashboard ? 'Tabletop exercises' : undefined}
      subtitle={isDashboard ? 'Plan, run and submit crisis rehearsals for your team.' : undefined}
      primaryAction={
        isDashboard ? (
          <TabletopHeaderActionsSlot
            fallback={
              <button
                type="button"
                onClick={() => navigate('/tabletop-exercises/new')}
                className="px-3.5 py-1.5 bg-[#991B1B] hover:bg-[#7F1D1D] text-white rounded-lg text-xs font-bold shadow-sm transition-colors flex items-center space-x-1"
              >
                <span>+</span>
                <span>New exercise</span>
              </button>
            }
          />
        ) : undefined
      }
      onNewExercise={() => navigate('/tabletop-exercises/new')}
    >
      <Routes>
        <Route path="/" element={<ExerciseDashboard hidePageHeader={isDashboard} />} />
        <Route path="/new" element={<CreateExerciseForm />} />
        <Route path="/new-from-ai" element={<Navigate to="/tabletop-exercises/new" replace />} />
        <Route path="/:id/edit" element={<CreateExerciseForm />} />
        <Route path="/:id" element={<ExerciseDetail />} />
      </Routes>
    </WorkspaceLayout>
  );
};

export default TableTopExercises;
